<script>
  import axios from 'axios';

  export default {
    name: "MainDepartment",
    props: {
      department: [String, Number],
    },
    data() {
      return {
        dialog_department: true,
        options: [],
        loading: true,
        form: {
          id: '',
        }
      }
    },
    methods: {
      click_department(v) {
        this.loading = true;
        if (v) axios.post('/tourclient/account/CurrentUserDepartment', `id=${this.form.id}`)
          .then(({data}) => {
            if (data.Success) this.$emit('change', true);
            else this.logout();
          });
        else this.logout();
      },
      logout() {
        this.loading = true;
        axios
          .get('/tourclient/account/logout?_=' + (new Date().getTime()))
          .then(data => {
            this.$emit('change', false);
            this.loading = false;
          })
          .catch(err => {
            this.$emit('change', false);
            this.loading = false;
          })
      },
      get_department() {
        this.loading = true;
        axios
          .post('/tourclient/MasterAgent/Dictionary/Department', 'request=%7B%7D')
          .then(({data}) => {
            this.options = data.Items.map(i => {
              return {
                value: i.Id,
                label: i.Name,
              }
            });
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    mounted() {
      this.form.id = this.department;
      this.get_department();
    }
  }
</script>
<template>
  <el-dialog :visible="dialog_department" title="Необходимо выбрать офис" width="400px">
    <div v-loading="loading">
      <el-select v-model="form.id" style="width: 100%;">
        <el-option v-for="item in options" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
      <div style="text-align: right;margin-top: 36px;">
        <el-button @click="click_department(false)">Отмена</el-button>
        <el-button type="primary" @click="click_department(true)">Выбрать</el-button>
      </div>
    </div>
  </el-dialog>
</template>